import React from 'react';
import { useTranslation } from 'react-i18next';
import { SECTIONS, computeSectionProgress } from '../config/sections';

const SegmentedProgress = ({ currentSlideCode, quizData, slideNavigation }) => {
  const { t } = useTranslation();
  const progress = computeSectionProgress(currentSlideCode, quizData, slideNavigation);

  return (
    <div className="t-px-4 t-pb-2.5 -t-mt-3">
      <div className="t-flex t-gap-[3px]">
        {SECTIONS.map((sec, idx) => {
          const p = progress[idx];
          const labelClass = p.done ? 't-text-navy' : p.active ? 't-text-quiz-teal' : 't-text-g300';
          const fillClass = p.done ? 't-bg-navy' : 't-bg-quiz-teal';

          return (
            <div key={sec.id} className="t-flex-1 t-flex t-flex-col t-items-center t-gap-[3px]">
              <span
                className={`t-text-xs sm:t-text-sm t-font-bold t-uppercase t-tracking-wider t-whitespace-nowrap t-overflow-hidden t-text-ellipsis t-max-w-full ${labelClass}`}
              >
                {t(sec.labelKey)}
              </span>
              <div className="t-w-full t-h-[3px] sm:t-h-1 t-rounded-sm t-bg-g200 t-overflow-hidden">
                <div
                  className={`t-h-full t-rounded-sm ${fillClass} t-transition-all t-duration-400 t-ease-out`}
                  style={{ width: `${p.fillPercent}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SegmentedProgress;
